var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 31,
    viewBox: "0 0 33.893 30.239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "warning_black_24dp_3_",
    "data-name": "warning_black_24dp (3)",
    d: "M6.027,34.231H32.8A3.555,3.555,0,0,0,35.879,28.9L22.491,5.766a3.554,3.554,0,0,0-6.152,0L2.951,28.9a3.555,3.555,0,0,0,3.076,5.334ZM19.415,21.786a1.783,1.783,0,0,1-1.778-1.778V16.452a1.778,1.778,0,1,1,3.556,0v3.556A1.783,1.783,0,0,1,19.415,21.786ZM21.193,28.9H17.637V25.342h3.556Z",
    transform: "translate(-2.469 -3.992)",
    fill: "#fad753"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.489fdedee1b709206fd15bdcc40dc093.svg";
export { ForwardRef as ReactComponent };